import React from "react";
import { Link } from "gatsby";

const NeedHelp = ({ needHelp = [] }) => {
  return (
    <div className="w-[55%] pr-20 mb-5">
      <h3 className="text-3xl font-bold leading-[45px] tracking-wide">
        Need help?
      </h3>
      <div className="flex flex-wrap justify-start items-center mt-5 gap-4">
        {needHelp.map((value, id) => {
          if (value.slug.includes("bushbuck-club")) {
            return (
              <a
                href={value.slug}
                className="border-2 border-solid border-white text-white tracking-widest bg-transparent py-3 px-[35px] rounded-full
                hover:scale-105 duration-200 font-bold"
                key={id}
              >
                {value.title}
              </a>
            );
          } else {
            return (
              <Link
                to={value.slug}
                className="border-2 border-solid border-white text-white tracking-widest bg-transparent py-3 px-[35px] rounded-full
                    hover:scale-105 duration-200 font-bold"
                key={id}
              >
                {value.title}
              </Link>
            );
          }
        })}
      </div>
    </div>
  );
};

export default NeedHelp;
